<h1 matDialogTitle>
  <ng-container *ngIf="!data.id">New Customer</ng-container>
  <ng-container *ngIf="data.id">Edit Customer</ng-container>
</h1>
<mat-dialog-content>

  <aw-customer-form [customer]="data" (saved)="dialogRef.close(true)"
    (canceled)="dialogRef.close(false)"></aw-customer-form>

</mat-dialog-content>